export default [
  // Johto: Hauptspiel
  "Starter",
  "Route 29 (Gras)",
  "Route 30 (Gras)",
  "Route 31 (Gras)",
  "Ruhige Höhle (Höhle)",
  "Viola City (Geschenk: Togepi-Ei)",
  "Knofensa-Turm (Innen)",
  "Route 32 (Gras)",
  "Azalea-Wald (Gras)",
  "Alpha-Ruinen (Innen)",
  "Route 33 (Gras)",
  "Azalea City (Kurt: Aprikokos)",
  "Schleiede-Waldschrein (Event)",
  "Flegmon-Brunnen (Innen)",
  "Steineichenwald (Gras)",
  "Route 34 (Gras)",
  "Route 35 (Gras)",
  "Nationalpark (Käfer-Wettbewerb)",
  "Route 36 (Gras)",
  "Route 37 (Gras)",
  "Teak City (Geschenk: Evoli)",
  "Turmruine (Innen)",
  "Route 38 (Gras)",
  "Route 39 (Gras)",
  "Oliviana City (Angeln/Surfen möglich)",
  "Oliviana-Leuchtturm (Innen)",
  "Route 40 (Surfen)",
  "Route 41 (Surfen)",
  "Whirlpool-Inseln (Innen)",
  "Anemonia City (Angeln/Surfen)",
  "Route 42 (Gras)",
  "Felstunnel (Höhle)",
  "Route 43 (Gras)",
  "See des Zorns (Gras)",
  "Team Rocket-Versteck (Mahagonia)",
  "Route 44 (Gras)",
  "Eisweg (Höhle, Eisflächen)",
  "Route 45 (Gras)",
  "Route 46 (Gras)",
  "Route 27 (Gras)",
  "Tohjo-Fälle (Höhle)",
  "Route 26 (Gras)",
  "Siegesstraße (Höhle)",

  // Kanto: Postgame
  "Route 1 (Gras)",
  "Alabastia (Startertausch)",
  "Route 2 (Gras)",
  "Vertania-Wald (Gras)",
  "Vertania City (Geschenk: Togepi-Ei #2)",
  "Route 3 (Gras)",
  "Mondberg (Höhle)",
  "Route 4 (Gras)",
  "Route 5 (Gras)",
  "Route 6 (Gras)",
  "Route 7 (Gras)",
  "Route 8 (Gras)",
  "Route 9 (Gras)",
  "Felstunnel (Kanto) (Höhle)",
  "Route 10 (Gras)",
  "Kraftwerk (Elektek-Event)",
  "Lavandia (Geschenk: Plüschtier-Event)",
  "Route 11 (Gras)",
  "Route 12 (Angeln/Surfen)",
  "Route 13 (Gras)",
  "Route 14 (Gras)",
  "Route 15 (Gras)",
  "Route 16 (Gras)",
  "Route 17 (Radweg/Gras)",
  "Route 18 (Gras)",
  "Route 19 (Surfen)",
  "Route 20 (Surfen)",
  "Seeschauminseln (Innen, Höhle)",
  "Route 21 (Surfen)",
  "Route 22 (Gras)",
  "Route 23 (Gras)",
  "Digda-Höhle (Höhle)",
  "Felsenhöhle (Mewtu-Event)",
  "Safari-Zone",

  // Sonstige und Spezialorte
  "Duellplatz (Kampfeinrichtung)",
  "Kampfzone (Battle Frontier)",
  "Sinjoh-Ruinen (Event)",
  "PokeWalker (je nach Karte)",
  "Fossil-1 ",
  "Fossil-2",
  "Fossil-3",
  "Fossil-4",
  "Fossil-5",
  "Extra-1",
  "Extra-2",
  "Extra-3",
  "Extra-4",
  "Extra-5",
  "Shiny",
  "Mistmon of the Year"
];